import React from "react";

export function LittleSplashMark({ className = "", light = false }) {
  const sun = light ? "#e7b576" : "#c97049";
  const rays = light ? "#f0d9ad" : "#e7b576";
  const wave1 = light ? "#ffffff" : "#00334a";
  const wave2 = light ? "#bcd0d2" : "#65949c";
  return (
    <svg viewBox="0 0 56 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* rays */}
      <g stroke={rays} strokeWidth="1.6" strokeLinecap="round">
        <line x1="28" y1="3" x2="28" y2="9" />
        <line x1="16.5" y1="7.5" x2="19.5" y2="12.5" />
        <line x1="39.5" y1="7.5" x2="36.5" y2="12.5" />
        <line x1="9" y1="18" x2="14.5" y2="20.5" />
        <line x1="47" y1="18" x2="41.5" y2="20.5" />
      </g>
      {/* rising sun (semicircle) */}
      <path d="M15 27 a13 13 0 0 1 26 0" stroke={sun} strokeWidth="2.2" strokeLinecap="round" />
      {/* waves */}
      <path d="M4 33 q6 -5 12 0 t12 0 t12 0 t12 0" stroke={wave1} strokeWidth="2.2" strokeLinecap="round" />
      <path d="M4 40 q6 -5 12 0 t12 0 t12 0 t12 0" stroke={wave2} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

export function Brand({ light = false, className = "", subtitle = true }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <LittleSplashMark light={light} className="h-9 w-11 shrink-0" />
      <div className="leading-none">
        <div
          className={`font-heading text-xl font-semibold tracking-[0.12em] ${
            light ? "text-white" : "text-[#00334a]"
          }`}
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          LITTLE SPLASH
        </div>
        {subtitle && (
          <div
            className={`mt-1 text-[9px] font-semibold uppercase tracking-[0.34em] ${
              light ? "text-[#e7b576]" : "text-[#c97049]"
            }`}
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Swim Program · Hope Floats
          </div>
        )}
      </div>
    </div>
  );
}
